const initializedLists = new WeakSet();

function getProductItems(list) {
  return Array.from(list.querySelectorAll(':scope > .catalog-page__item:not(.catalog-page__item_store-features)'));
}

function getColumnsCount(list, productItems) {
  const columns = window.getComputedStyle(list).gridTemplateColumns.trim().split(/\s+/).filter(Boolean);

  if (columns.length > 1) {
    return columns.length;
  }

  const firstRowTop = Math.min(...productItems.map((item) => item.getBoundingClientRect().top));
  return productItems.filter((item) => Math.abs(item.getBoundingClientRect().top - firstRowTop) < 1).length;
}

function updateDivider(list) {
  const productItems = getProductItems(list);
  const oddDivider = list.querySelector(':scope > .catalog-page__item_store-features_odd-columns');
  const evenDivider = list.querySelector(':scope > .catalog-page__item_store-features_even-columns');

  if (!productItems.length) {
    return;
  }

  const columns = getColumnsCount(list, productItems);
  const showEvenDivider = columns % 2 === 0;

  if (oddDivider) {
    oddDivider.classList.toggle('_active', !showEvenDivider);
  }

  if (evenDivider) {
    evenDivider.classList.toggle('_active', showEvenDivider);
  }
}

function initializeDivider(list) {
  if (initializedLists.has(list)) {
    updateDivider(list);
    return;
  }

  initializedLists.add(list);
  const update = () => updateDivider(list);
  const resizeObserver = new ResizeObserver(update);

  resizeObserver.observe(list);
  requestAnimationFrame(update);
}

function initializeDividers() {
  document.querySelectorAll('.catalog-page__list').forEach(initializeDivider);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeDividers);
} else {
  initializeDividers();
}

document.addEventListener('DOMContentMutated', initializeDividers);
